import { render, staticRenderFns } from "./UnderFat.vue?vue&type=template&id=3f76bd92&"
import script from "./UnderFat.vue?vue&type=script&lang=js&"
export * from "./UnderFat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports